import * as angular from 'angular';

const createTable = (selector: string, options: DataTables.Settings) => {
    angular.element(selector).DataTable({
        ...options,
        pagingType: 'simple',
        pageLength: 20
    });
};

class TableDirective implements angular.IDirective {
    readonly replace = true;
    readonly transclude = true;
    readonly restrict = 'E';
    readonly scope = {};

    readonly template = ``;

    readonly link: angular.IDirectiveLinkFn;

    constructor() {
        this.link = this._link.bind(this);
    }

    private _link(): void {
        // To be implemented
    }
}

const TableDirectiveFactory: angular.IDirectiveFactory = () => new TableDirective();

export { createTable, TableDirectiveFactory };
